const h = {
  labelTextColor: "var(--gray-700)",
  feedbackTextColor: "var(--gray-600)",
  blankHeight: "var(--hr-line-height-2xl)",
  feedbackTextColorError: "var(--error-500)",
  labelFontWeight: "var(--hr-font-weight-medium)"
}, t = (e) => ({
  labelFontSize: "var(--hr-font-size-xs)",
  labelLineHeight: "var(--hr-line-height-xs)",
  feedbackFontSize: "var(--hr-font-size-2xs)",
  feedbackLineHeight: `calc( var(--hr-line-height-2xs) * ${e} )`,
  blankHeight: "var(--hr-line-height-xs)",
  labelHeight: "var(--hr-line-height-xs)"
}), l = (e) => ({
  labelFontSize: "var(--hr-font-size-sm)",
  labelLineHeight: "var(--hr-line-height-sm)",
  feedbackFontSize: "var(--hr-font-size-xs)",
  feedbackLineHeight: `calc( var(--hr-line-height-xs) * ${e} )`,
  blankHeight: "var(--hr-line-height-sm)",
  labelHeight: "var(--hr-line-height-sm)"
}), r = (e) => ({
  labelFontSize: "var(--hr-font-size-md)",
  labelLineHeight: "var(--hr-line-height-md)",
  feedbackFontSize: "var(--hr-font-size-sm)",
  feedbackLineHeight: `calc( var(--hr-line-height-sm) * ${e} )`,
  blankHeight: "var(--hr-line-height-md)",
  labelHeight: "var(--hr-line-height-md)"
}), a = (e) => ({
  labelFontSize: "var(--hr-font-size-lg)",
  labelLineHeight: "var(--hr-line-height-lg)",
  feedbackFontSize: "var(--hr-font-size-md)",
  feedbackLineHeight: `calc( var(--hr-line-height-md) * ${e} )`,
  blankHeight: "var(--hr-line-height-lg)",
  labelHeight: "var(--hr-line-height-lg)"
}), n = (e) => ({
  labelFontSize: "var(--hr-font-size-2xl)",
  labelLineHeight: "var(--hr-line-height-2xl)",
  feedbackFontSize: "var(--hr-font-size-lg)",
  feedbackLineHeight: `calc( var(--hr-line-height-lg) * ${e} )`,
  blankHeight: "var(--hr-line-height-2xl)",
  labelHeight: "var(--hr-line-height-2xl)"
}), g = (e) => ({
  labelFontSize: "var(--hr-font-size-2xl)",
  labelLineHeight: "var(--hr-line-height-2xl)",
  feedbackFontSize: "var(--hr-font-size-lg)",
  feedbackLineHeight: `calc( var(--hr-line-height-lg) * ${e} )`,
  blankHeight: "var(--hr-line-height-2xl)",
  labelHeight: "var(--hr-line-height-2xl)"
});
function s(e = "2xs", i = 1) {
  return {
    ...h,
    ...{
      lg: g,
      md: n,
      sm: a,
      xs: r,
      "2xs": l,
      "3xs": t
    }[e](i)
  };
}
export {
  s as createFormInputSizes
};
